module.exports = __webpack_public_path__ + "media/images/shield-ad5c8f430f54253688f2d4aa92609531.svg";